import React from 'react';

type ScrollableSelectContainerProps = {
  children: React.ReactNode;
};

const ScrollableSelectContainer: React.FC<ScrollableSelectContainerProps> = ({
  children,
}) => {
  const childrenArray = React.Children.toArray(children);
  const emptySlots = 4 - (childrenArray.length % 4);

  return (
    <div className="flex flex-col sm:grid sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-4 w-full justify-end">
      {childrenArray.map((child, index) => (
        <div key={index} className="">
          {child}
        </div>
      ))}
      {emptySlots !== 4 && Array(emptySlots).fill(null).map((_, index) => (
        <div key={`empty-${index}`} className="w-auto"></div>
      ))}
    </div>
  );
};

export default ScrollableSelectContainer;